import { Injectable } from '@angular/core';

@Injectable()
export class AdaService {

  constructor() { }

  initGrid(event) {
    const element: HTMLElement = event.element;
    const elements: NodeListOf<Element> = element.getElementsByClassName('dx-context-menu');
    let i = 0;
    for (let elementX = elements.item(i); i < elements.length; i++) {
      elementX.removeAttribute("role");
    }
  }

  initElement(event, elementType, manualLabel = null) {
    const element: HTMLElement = event.element;
    const assignValue = manualLabel ? manualLabel : element.getAttribute("placeholder");
    // const
    const elements: NodeListOf<Element> = element.getElementsByTagName(elementType);
    for (let i = 0; i < elements.length; i++) {
      let elementX = elements.item(i);
      elementX.setAttribute('aria-label', assignValue);
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/services/ada.service.ts